import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { getReviewInClaimEligibilityLineItemsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import ReviewInClaimEligibilityTable from './ReviewInClaimEligibilityTable';
import ReviewInClaimEligibilityFilterButton from './ReviewInClaimEligibilityFilterButton';
import ReviewInClaimEligibilityFilterStatusBar from './ReviewInClaimEligibilityFilterStatusBar';

const ReviewInClaimEligibility = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(
    ({ workQueue }) => workQueue.reviewInClaimEligibility,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.REVIEW_IN_CLAIM_ELIGIBILITY)) {
      dispatch(getReviewInClaimEligibilityLineItemsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.REVIEW_IN_CLAIM_ELIGIBILITY) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <ReviewInClaimEligibilityFilterStatusBar />
      </Grid>
      <Grid item>
        <ReviewInClaimEligibilityFilterButton />
      </Grid>
      <ReviewInClaimEligibilityTable />
    </Grid>
  );
};

export default ReviewInClaimEligibility;
